export const FIND_DOCUMENT_REQUEST = 'FIND_DOCUMENT_REQUEST';

export const findDocumentRequest = ( id ) => ({
    type: FIND_DOCUMENT_REQUEST,
    payload: { id }
});
